import type { IntegrationDTO } from '../api/types';
import { IntegrationStatus, type Integration } from '../model/types';

export const mapIntegration = <T>(dto: IntegrationDTO<T>): Integration<T> => {
  return {
    id: dto.id,
    sourceIntegrationId:
      dto.sourceIntegrationId as Integration['sourceIntegrationId'],
    integrationConfig: dto.integrationConfig,
    updatedAt: dto.updatedAt,
    lastSuccessfulSync: dto.lastSuccessfulSync,
    lastWebhookReceivedAt: dto.lastWebhookReceivedAt,
    status: mapIntegrationStatus(dto.status),
    isConfigured: dto.isConfigured,
  };
};

const mapIntegrationStatus = (
  dtoStatus: IntegrationDTO['status'],
): IntegrationStatus => {
  switch (dtoStatus) {
    case 'connected':
      return IntegrationStatus.connected;
    case 'failed':
      return IntegrationStatus.failed;
    case 'pending':
      return IntegrationStatus.pending;
    default:
      return IntegrationStatus.connected;
  }
};
